import { render } from "./SalidaAlmacen.vue?vue&type=template&id=510380cd"
import script from "./SalidaAlmacen.vue?vue&type=script&lang=js"
export * from "./SalidaAlmacen.vue?vue&type=script&lang=js"

import "./SalidaAlmacen.vue?vue&type=style&index=0&id=510380cd&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__